import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountryInput = _resolveComponent("CountryInput")!

  return (_openBlock(), _createBlock(_component_CountryInput, {
    modelValue: _ctx.selectedCountries,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCountries) = $event))
  }, null, 8, ["modelValue"]))
}